import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import ReactPaginate from 'react-paginate';
import { Row } from 'reactstrap'


const ReportMasterTable = ({ displayDataset }) => {

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchString, setSearchString] = useState("");
    const searchref = useRef(null); //search input ref
    const [searcHColumn, setSearchColumn] = useState("")
    const [searchPlaceholder, setSearchPlaceholder] = useState("Click on column to search...")


    useEffect(() => {
        setPageNo(1)
        setSearchString("")
        setSearchColumn("")
        setSearchPlaceholder("Click on column to search...")
    }, [displayDataset])

    const filteredData = displayDataset.filter((row) => {
        return Object.keys(row).some((key) => {
            if (searcHColumn === "") {
                return row[key].toString().toLowerCase().indexOf(searchString.toLowerCase()) > -1
            } else {
                return row[searcHColumn].toString().toLowerCase().indexOf(searchString.toLowerCase()) > -1
            }
        })
    })



    const indexOfLastPost = pageNo * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize
    const currentGroupRows = filteredData.slice(indexOfFirstPost, indexOfLastPost)

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };

    const columns = displayDataset.length > 0 ? Object.keys(displayDataset[0]) : [];

    // const getColumnWidth = (column) => {
    //     const columnData = displayDataset.map(row => String(row[column]));
    //     const maxWidth = Math.max(...columnData.map(cell => cell.length));
    //     return Math.min(maxWidth * 10, 300);
    // };

    const getColumnWidth = (column) => {
        const columnData = displayDataset[0];
        const maxWidth = String(columnData[column]).length;
        return Math.min(maxWidth * 10, 300);
    };

    return (
        <React.Fragment >
            {displayDataset.length > 0 ? <Row style={{ paddingTop: '20px' }}>
                <div className="row mb-3 justify-content-end">
                    <div className="col-3">
                        <div className="form-group">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><i className="mdi mdi-magnify"></i></span>
                                </div>
                                <input ref={searchref} id="SearchBarDynamic" type="text" className="form-control" placeholder={searchPlaceholder} aria-label="Username" aria-describedby="basic-addon1" onChange={e => {
                                    setSearchString(e.target.value) // set search string
                                    setPageNo(1) // set page no to 0  when search string change
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            </Row> : null}
            <Row>
                {displayDataset.length > 0 ? <div style={{ overflowX: 'auto' }}>
                    <table className="table table-bordered  table-sm rounded">
                        <thead >
                            <tr>
                                <th>#</th>
                                {columns.map((column) => (
                                    <th key={column} style={{
                                        width: getColumnWidth(column),
                                        cursor: 'pointer'
                                    }}
                                        onClick={() => {
                                            setSearchColumn(column)
                                            setSearchPlaceholder(`Search in ${column}`)
                                        }}
                                    >
                                        {column}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {currentGroupRows.map((row, index) => {
                                const values = columns.map(column => row[column]);
                                return (
                                    <tr key={index}>
                                        <td style={{ width: '20px' }}>{indexOfFirstPost + index + 1}</td>
                                        {values.map((value, index) => (
                                            <td key={index} style={{
                                                width: 'auto',
                                                textAlign: typeof value === "number" ? "right" : "left",
                                            }}>
                                                {value}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div> : null}
            </Row>
            <Row className='mt-2'>
                <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(filteredData.length / pageSize)}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    forcePage={pageNo - 1}
                    renderOnZeroPageCount={null}
                    activeClassName={'active'}
                    activeLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-end pagination-sm'}
                />
            </Row>
        </React.Fragment>
    )

}

export default ReportMasterTable;

